import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function PutClientType(
        data,
        countryUuid
    ) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/client/type/' +  data.uuid + "?countryUuid=" + countryUuid, {
            method: 'PUT',
            headers: { 'Authorization' : unHashedJwt},
            data: {
                "client_type_name": data.client_type.trim()               
            }      
        }).then(
            res => (res)
        ).catch(error => error.response.data)
    )
}